import { Typography, Paper, Grid2 } from "@mui/material";
import { useCustom } from "@refinedev/core";
import { useMarketplaceStore } from "../../store/useMarketplaceStore";
import { useParams } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import { ProductDetail } from "./components/types";
import { Price } from "./components/papers/Price";
import { Seller } from "./components/papers/Seller";
import { Cost } from "./components/papers/Cost";
import { Other } from "./components/papers/Other";
import { Detail } from "./components/papers/Detail";
import { OtherSellers } from "./components/papers/OtherSellers";
import { USStore } from "./components/papers/USStore";
import { SyncrosaleLoader } from "../../components/layout/components/SyncrosaleLoader";

export const Product = () => {
  const { asin } = useParams<{ asin: string }>();
  const UpperCaseAsin = asin?.toUpperCase();
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);
  const { translate } = useTranslation("pages.product");
  const { data: productResponse, isLoading } = useCustom<ProductDetail>({
    url: selectedCountry
      ? `store/${selectedCountry.id}/product/${UpperCaseAsin}`
      : "",
    method: "get",
    queryOptions: {
      enabled: !!selectedCountry && !!asin,
      queryKey: ["product", asin],
    },
  });
  const productDetail = productResponse?.data;
  if (isLoading) {
    return <SyncrosaleLoader />;
  }

  if (!productDetail) {
    return <Paper sx={{ padding: 3 }}>{translate("notFound")}</Paper>;
  }

  return (
    <Paper sx={{ padding: 3 }}>
      <Typography variant="h6" textAlign="center" gutterBottom>
        {translate("productDetail")}
      </Typography>
      <Grid2
        container
        spacing={2}
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "stretch",
        }}
      >
        <Grid2 size={{ xs: 12, lg: 12 }}>
          <Detail productDetail={productDetail} />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 4 }}>
          <Price productDetail={productDetail} />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 4 }}>
          <Cost productDetail={productDetail} />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 4 }}>
          <Seller productDetail={productDetail} />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 4 }}>
          <USStore productDetail={productDetail} />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 4 }}>
          <OtherSellers productDetail={productDetail} />
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 4 }}>
          <Other productDetail={productDetail} />
        </Grid2>
      </Grid2>
    </Paper>
  );
};
